export default __webpack_public_path__ + "static/media/fitness.ff94dee0.jpg";